import React from "react";
import { Box, Typography, List, ListItem, ListItemText } from '@mui/material';


export function ChecklistSection(props: { title: string; items: string[] }) {
  const { title, items } = props;

  return (
    <Box sx={{ mb: 2 }}>
      <Typography
        sx={{
          fontWeight: 900,
          color: "#111827",
          mb: 0.75,
        }}
      >
        {title}
      </Typography>

      <List dense disablePadding>
        {items.map((label, i) => (
          <ListItem key={i} disableGutters sx={{ py: 0.25 }}>
            <ListItemText
              primary={
                <Typography sx={{ fontWeight: 600, color: "#374151" }}>
                  - {label}
                </Typography>
              }
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
}

// Vibe question categories
export type Category = "aware" | "prepare" | "share";
export const categoryConfig = {
  aware: { title: "Aware" },
  prepare: { title: "Prepare" },
  share: { title: "Share" },
};

export const categoryOrder: Category[] = [
  "aware",
  "prepare",
  "share"
];

export const GENDER_OPTIONS = [
  { value: "male", label_en: "Male", label_de: "Männlich" },
  { value: "female", label_en: "Female", label_de: "Weiblich" },
  { value: "other", label_en: "Other", label_de: "Divers" },
];

// profile
export type EmployeeRow = {
  id: string;
  first_name: string | null;
  last_name: string | null;
  age: number | null;
  gender: string | null;
  location: string | null;
  position: string | null;
  company_email: string | null;
  avatar_url: string | null;
  company_id: string | null;
};

export type CompanyRow = {
  id: string;
  name: string | null;
};